import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Plus, Minus } from "../../utils";
import { CounterRow, CounterLabel, CounterContainer, CounterButton, Counter} from "./styles";

class AmountCounter extends Component {
  static propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
    guestAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    handleChange: PropTypes.func.isRequired,
    hiddenCounter: PropTypes.bool,
    disabledInc: PropTypes.bool,
    setWarning: PropTypes.func,
    disabled: PropTypes.bool,
  };

  state = {
    counter: null,
  };

  componentDidMount() {
    const { guestAmount } = this.props;
    this.setState({
      counter: Number(guestAmount),
    });
  };

  componentDidUpdate(prevProps) {
    const { guestAmount: newGuestAmount } = this.props;
    const { guestAmount: prevGuestAmount } = prevProps;

    if(newGuestAmount !== prevGuestAmount){
      this.setState({ counter: newGuestAmount })
    }
  }

  handleIncrementCounter = () => {
    const { counter } = this.state;
    const { handleChange } = this.props;
    this.setState(prevState => ({
      counter: prevState.counter + 1,
    }));
    handleChange(counter + 1);
  };

  handleDecrementCounter = () => {
    const { counter } = this.state;
    const { handleChange, setWarning, disabled } = this.props;
    if(disabled) return

    if(setWarning !== undefined) {
      setWarning(false);
    }

    if (counter > 1) {
      this.setState(prevState => ({
        counter: prevState.counter - 1,
      }));
      handleChange(counter - 1);
    }
  };

  render() {
    const { counter } = this.state;
    const { label, hiddenCounter, disabledInc, setWarning, disabled } = this.props;
    return (
      <CounterRow>
        <CounterLabel>{label}</CounterLabel>
        <CounterContainer>
          <CounterButton type="button" name="decrement" dis={disabled} onClick={this.handleDecrementCounter}>
            <Minus width={10} height={2} />
          </CounterButton>
          <Counter hiddenCounter={hiddenCounter}>{counter}</Counter>
          <CounterButton type="button" name="increment" dis={disabledInc || disabled} onClick={disabledInc || disabled ? () => setWarning(true) : this.handleIncrementCounter}>
            <Plus width={10} height={10} />
          </CounterButton>
        </CounterContainer>
      </CounterRow>
    );
  }
}

export default AmountCounter;
